import { FormControl, Grid, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import { LinearLoading } from 'common'
import React from 'react'
import { FieldContract } from '../FieldsForForms'

export const GeneralFields = (props) => {

    const {Forms, FetchData, globalStates, Actions} = props

    const {FormRequestGlobal:{formState, onSelectSearchChange}} = Forms

    const {formOpeningMode} = globalStates

    const {fetchAllContracts:{loadingFetchContracts}} = FetchData
    
    const { fetchAllTypeManagements } = FetchData
    const { typeManagements, loadingFetchTypeManagements } = fetchAllTypeManagements

    const {handleChangeContract} = Actions

  return (
    <>
        <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
            General
        </Typography>
        <div className="border-bottom border-dark"></div>
        {(loadingFetchTypeManagements || loadingFetchContracts) && <LinearLoading />}
        {(!loadingFetchTypeManagements && !loadingFetchContracts) && (
            <>    
                <FieldContract
                    //Propiedades del formulario
                    formState={formState}
                    handleChangeContract={handleChangeContract}

                    //FetchData
                    FetchData={FetchData}

                    //Configuraciones
                    disable={true}
                />
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="idgestiontipo"> * Tipo de Gestion</label>
                            <CustomAutocomplete
                            customId="idgestiontipo"
                            customName="idgestiontipo"
                            customValue={formState.idgestiontipo}
                            // customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idgestiontipo', value: value.value }  })}
                            customPlaceholder='Seleccione una gestion'
                            customOptions={
                                typeManagements.map(({ idgestiontipo, prefijo, descripcion }) => ({
                                value: idgestiontipo,
                                name: (prefijo+' - '+descripcion)
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={true}
                            />
                        </FormControl>
                    </Grid> 
                </Grid>
            </> 
        )}
    </>
  )
}
